import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { CompanyDashboardSetting } from "~/models/CompanyDashboardSetting";
import { generatePath } from "~/utils/generatePath";

export const useCompanyDashboardSetting =
	(): SwrReturnType<CompanyDashboardSetting> => {
		const { data, mutate, error, isLoading } = useSWR<CompanyDashboardSetting>(
			generatePath("/company_dashboard_setting")
		);
		return {
			data: data ?? null,
			error,
			isLoading,
			mutate
		};
	};
